<template>
  <div>
    <AppChangePassword
      v-if="pwdToggle"
      @pwdToggleChange="pwdToggleChange"
      @showSingleBtnDialog="showSingleBtnDialog"
      class="pop-top"
    />
    <div class="app-wrap">
      <AppMyPageHeader/>
      <ul class="my-list-group">
        <li class="my-list-item name">
          <div class="icon"/>
          <div class="info">
            <span class="name"><span>{{ name }}</span>님</span>
            <span>연락처 {{ phone }}</span>
          </div>
        </li>
        <ul>
          <!-- <li class="menu-list-item">지갑관리</li> -->
          <li @click="seerooWallet()" class="menu-list-item" tag="li">
            <div class="icon"/>결제수단 관리
          </li>
          <li class="menu-list-item" @click="pwdToggleChange">
            <div class="icon"/>
            비밀번호 변경
          </li>
          <RouterLink :to="{ name: 'AppMyMenu' }" class="menu-list-item" tag="li">
            <div class="icon"/>
            관심상품
          </RouterLink>
          <RouterLink :to="{ name: 'AppSetting' }" class="menu-list-item" tag="li">
            <div class="icon"/>
            설정
          </RouterLink>
          <!-- <RouterLink :to="{ name: 'AppNotice' }" class="menu-list-item" tag="li">공지사항</RouterLink> -->
        </ul>
      </ul>
      <form :action="srWalletUrl" id="srWallet_form" method="GET" ref="srWallet_form">
        <input type="hidden" name="e" ref="eInput">
        <input type="hidden" name="errorUrl" ref="errorUrlInput">
        <input type="hidden" name="k" ref="kInput">
        <input type="hidden" name="merchantCode" ref="merchantCodeInput">
        <input type="hidden" name="merchantId" ref="merchantIdInput">
        <input type="hidden" name="mpStoreId" ref="mpStoreIdInput">
      </form>
    </div>
    <SingleBtnDialog
      v-if='showSingleBtnDialogFlag'
      :messageType='singleBtnMsgType'
      :onClickConfirmBtn='onClickConfirmBtn'/>
  </div>
</template>

<script lang="js">
import SingleBtnDialog from '@/components/Dialog/SingleBtnDialog.vue'
import service from '@/backend/modnpay_app_api'
import { THROW_APP_ERROR, THROW_APP_LOGIN_OVER_LAP } from '@/router'
import AppMyPageHeader from '@/components/Header/AppMyPageHeader.vue'
// import AppCompanyInfo from '@/components/App/AppCompanyInfo.vue'
// import BottomMenu from '@/components/App/BottomMenu.vue'
import AppChangePassword from '@/views/AppChangePassword.vue'
import Store from '@/store'

/* eslint-disable eqeqeq */
export default {
  components: {
    // AppCompanyInfo,
    // BottomMenu,
    SingleBtnDialog,
    AppMyPageHeader,
    AppChangePassword
  },
  data () {
    return {
      name: '',
      phone: '',
      srWalletUrl: '',
      pwdToggle: false, // 비밀번호 변경 팝업
      showSingleBtnDialogFlag: false // single btn Dialog show flag
    }
  },
  mounted () {
    if (this.isUser) {
      this.myInfo()
    }
    window.backBtn = () => {
      this.backBtn()
    }
  },
  methods: {
    backBtn () {
      if (this.pwdToggle) {
        this.pwdToggle = false
      } else {
        window.location.href = sessionStorage.getItem('backUrl')
      }
    },
    callForm () {
      console.log('url:', this.srWalletUrl)
      const form = this.$refs.srWallet_form
      const formData = new FormData(form)

      // FormData를 URLSearchParams로 변환
      const params = new URLSearchParams()
      for (const [key, value] of formData.entries()) {
        params.append(key, value)
      }
      this.$refs.srWallet_form.action = this.srWalletUrl
      // 폼의 action 속성과 쿼리 문자열을 조합해 URL 출력
      const fullUrl = `${form.action}?${params.toString()}`
      console.log(fullUrl) // 최종 URL 출력
      window.location.replace(fullUrl)
      // this.$refs.srWallet_form.submit()
    },
    setFormData (data) {
      this.srWalletUrl = data.srWalletUrl
      this.$refs.eInput.value = data.e
      this.$refs.errorUrlInput.value = encodeURIComponent(data.errorUrl)
      this.$refs.kInput.value = data.k
      this.$refs.merchantCodeInput.value = data.merchantCode
      this.$refs.merchantIdInput.value = data.merchantId
      this.$refs.mpStoreIdInput.value = data.mpStoreId
    },
    async seerooWallet () {
      const referer = window.location.href
      const req = {
        closeUrl: referer,
        amount: this.appFlag ? this.appTotalPrice : this.menuPrice,
        userValue: localStorage.getItem('appUserCode'),
        posSeq: localStorage.getItem('posSeq'),
        // orderSeq: localStorage.getItem('orderSeq'),
        storeGroupCode: Store.getters.storeGroupCode
      }

      const { data } = await service.seerooWallet(req)
      this.urlData = data
      this.srWalletUrl = data.srWalletUrl
      this.setFormData(this.urlData)
      this.callForm()
    },
    async myInfo () { // 사용자 정보 조회
      const req = {
        userCode: ''
      }
      const { data } = await service.myInfo(req)
      const code = data.resultCode
      if (code == 0) {
        this.name = data.name
        this.phone = data.phone
      } else if (code == 15033) {
        THROW_APP_LOGIN_OVER_LAP()
      } else {
        THROW_APP_ERROR()
      }
    },
    pwdToggleChange () {
      this.pwdToggle = !this.pwdToggle
    },
    showSingleBtnDialog (message) {
      this.singleBtnMsgType = message
      this.onClickConfirmBtn = () => {
        this.pwdToggleChange()
        this.showSingleBtnDialogFlag = false
      }
      this.showSingleBtnDialogFlag = true
    }
  },
  computed: {
    myShowFlag () {
      return this.myShow ? 'active' : ''
    }
    // orderSeq () {
    //   return this.$store.getters.orderSeq
    // }
  }
}
</script>
<style scoped>
  #footer {
    margin-bottom: 0vw;
    padding-bottom: 76px;
  }
</style>
